/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withRouter from 'HOCs/withRouter';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import ImageTile from './ImageTile';
import { selectAdpvGalleryNavigationTilesImages } from 'Selectors/items';
import css from './GalleryNavigationTiles.APP_TARGET.scss';
import { GALLERY_NAVIGATION_TILE_NAME } from 'Constants/items';
import withConfig from 'HOCs/withConfig/withConfig';
import { isMobile } from 'Helpers/devices';
import { SPIN_CAR_GIF_MOBILE, SPIN_CAR_GIF_DESKTOP } from 'Constants/imageUrls';
import { ADPV_EVENTS, FLOW_STEP, ITEM_TAP_IMAGE } from 'Constants/tracking';
import { LayoutHelper } from 'olx-autos-landing-page';

export const MAX_TILES = 5;

export function GalleryNavigationTiles({
    navigationImages,
    router,
    location: { pathname },
    intl,
    config,
    onTrack
}) {
    if (!navigationImages.length) {
        return null;
    }

    const onTileClick = sectionClicked => {
        onTrack(ADPV_EVENTS.INSPECTION_AREA, {
            flow_step: FLOW_STEP.GALLERY,
            chosen_option: sectionClicked,
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        });

        if (sectionClicked !== GALLERY_NAVIGATION_TILE_NAME.SPIN_CAR) {
            onTrack(ITEM_TAP_IMAGE, {
                select_from: sectionClicked,
                flow_step: FLOW_STEP.GALLERY,
                ...LayoutHelper.getAcquisitionChannelTrackingValues()
            });
        }
        router.push(`${pathname}/gallery-navigation/${sectionClicked}`);
    };

    const handleViewMoreTap = ev => {
        ev.stopPropagation();
        onTrack(ADPV_EVENTS.INSPECTION_AREA, {
            chosen_option: 'view_more',
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        });
        onTileClick(navigationImages[0].id);
    };

    const getTiles = () => {
        const tempTiles = navigationImages.reduce((acc, { image, name, id }) => {
            if (image) {
                if (id === GALLERY_NAVIGATION_TILE_NAME.SPIN_CAR) {
                    const staticAssetUrl = config.get('staticAssets');
                    const siteCode = config.get('siteCode');

                    const urlSuffix = isMobile ? SPIN_CAR_GIF_MOBILE : SPIN_CAR_GIF_DESKTOP;

                    const spinCarGifUrl = `${staticAssetUrl}/${siteCode}${urlSuffix}`;

                    acc.push((
                        <ImageTile
                            key={ id }
                            id={ id }
                            name={ `360 ${intl.formatMessage({ id: 'view' })}` }
                            url={ spinCarGifUrl }
                            onClick={ onTileClick }
                            css={ css } />
                    ));
                }
                else {
                    const { url } = image || {};

                    if (url) {
                        acc.push((
                            <ImageTile
                                key={ id }
                                id={ id }
                                name={ name || intl.formatMessage({ id }) }
                                url={ url }
                                onClick={ onTileClick }
                                css={ css }
                            />
                        ));
                    }
                }
            }

            return acc;
        }, []);

        if (tempTiles.length > MAX_TILES) {
            const viewMoreText = intl.formatMessage({ id: 'viewMore' });

            tempTiles.splice(MAX_TILES - 1, tempTiles.length - MAX_TILES + 1, (
                <div key={ viewMoreText } className={ cx(css.inspectionImagesTiles__tile, css.viewMore) } onClick={ handleViewMoreTap }>
                    { viewMoreText }
                </div>
            ));
        }

        return tempTiles;
    };

    return (
        <div className={ css.inspectionImagesTiles } data-aut-id="tile-seller-gallery">
            { getTiles() }
        </div>
    );
}

GalleryNavigationTiles.propTypes = {
    navigationImages: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        image: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            url: PropTypes.string
        })
    })),
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    router: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
    }).isRequired,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    onTrack: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
    return {
        navigationImages: selectAdpvGalleryNavigationTilesImages(state, ownProps)
    };
};

export default compose(
    injectIntl,
    withRouter,
    withConfig,
    connect(mapStateToProps),
    React.memo
)(GalleryNavigationTiles);
